import type { ReactNode } from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type Tone = 'green' | 'red' | 'amber' | 'slate' | 'blue';

const TONES: Record<Tone, string> = {
  green: 'border-success/30 bg-success/10 text-success',
  red: 'border-destructive/30 bg-destructive/10 text-destructive',
  amber: 'border-warning/40 bg-warning/15 text-amber-700 dark:text-warning',
  slate: 'border-border bg-muted text-muted-foreground',
  blue: 'border-primary/30 bg-primary/10 text-primary',
};
const DOTS: Record<Tone, string> = { green: 'bg-success', red: 'bg-destructive', amber: 'bg-warning', slate: 'bg-muted-foreground/60', blue: 'bg-primary' };

export function ToneBadge({ tone = 'slate', dot, children, className }: { tone?: Tone; dot?: boolean; children: ReactNode; className?: string }) {
  return (
    <Badge variant="outline" className={cn('font-medium', TONES[tone], className)}>
      {dot && <span className={cn('size-1.5 rounded-full', DOTS[tone])} />}
      {children}
    </Badge>
  );
}

export const statusTone = (s: string): Tone => (s === 'accepted' ? 'green' : s === 'failed' ? 'red' : s === 'queued' ? 'amber' : 'slate');
export const outcomeTone = (e: string): Tone => (e === 'failed' ? 'red' : e === 'clicked' ? 'blue' : 'green');

export const StatusBadge = ({ status }: { status: string }) => <ToneBadge tone={statusTone(status)} dot>{status}</ToneBadge>;
